import { jsxs, jsx } from 'react/jsx-runtime';
import { keyframes, styled } from 'styled-components';
import { cssVar } from '../theme/variables.js';
import { Flex } from './Flex.js';

const SpinnerAnimation = keyframes([
  `100%{transform:rotate(0deg);}0%{transform:rotate(360deg);}`
]);
const FullScreenSpinner = ({ children }) => {
  return /* @__PURE__ */ jsxs(Flex, {
    justifyContent: "center",
    alignItems: "center",
    direction: "column",
    gap: "sections",
    style: {
      height: "100vh",
      width: "100vw",
      background: cssVar["color-bg-primary"]
    },
    children: [
      /* @__PURE__ */ jsx(Spinner, {
        size: 25,
        thickness: 3
      }),
      children
    ]
  });
};
const Spinner = styled.div.withConfig({
  displayName: "Spinner",
  componentId: "sc-3daaa0a9-0"
})([
  `--spinner-color:`,
  `;position:relative;width:`,
  `px;height:`,
  `px;border-radius:50%;border:`,
  `px solid var(--spinner-color);mask:conic-gradient(from 160.71deg at 50% 50%,#ffffff 0deg,rgba(0,0,0,0) 300deg);display:inline-block;box-sizing:border-box;animation:`,
  ` 1s linear infinite;`
], (props) => props.color ?? cssVar["color-app-primary"], (props) => props.size ?? 48, (props) => props.size ?? 48, (props) => props.thickness ?? (props.size ?? 48) * 0.2, SpinnerAnimation);

export { FullScreenSpinner, Spinner };
//# sourceMappingURL=Spinner.js.map
